"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var getDomEventPosition = function (event, doc) {
    var x = -1;
    var y = -1;
    if (event.hasOwnProperty('pageX')) {
        x = event.pageX;
        y = event.pageY;
    }
    else if (event.clientX || event.clientY) {
        x = event.clientX + doc.body.scrollLeft + doc.documentElement.scrollLeft;
        y = event.clientY + doc.body.scrollTop + doc.documentElement.scrollTop;
    }
    return {
        x: ~~x,
        y: ~~y,
    };
};
exports.default = (function (event, domElement) {
    var doc = domElement.ownerDocument;
    var viewPosition = getDomEventPosition(event, doc);
    var elementRect = domElement.getBoundingClientRect();
    var x = viewPosition.x - elementRect.left;
    var y = viewPosition.y - elementRect.top;
    if (domElement.offsetWidth !== elementRect.width) {
        x *= domElement.offsetWidth / elementRect.width;
    }
    if (domElement.offsetHeight !== elementRect.height) {
        y *= domElement.offsetHeight / elementRect.height;
    }
    return {
        x: x,
        y: y,
        pageX: viewPosition.x,
        pageY: viewPosition.y,
    };
});
//# sourceMappingURL=getLocalDomEventPosition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/renderers/dom/getLocalDomEventPosition.js
// module id = 131
// module chunks = 35783957827783 127651196306611 162898551421021